// @ts-nocheck
import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useReportingMap } from 'sonata-platform-components';
import { Map as MapComponent } from 'sonata-platform-components/lib/types/types/reportingMap.types';
import { Selector, SelectorOptionPropsInterface } from 'sonata-react-components';
import { isDOOHCampaign } from 'sonata-static-storage/lib/helpers/campaign.helpers';

import { getDefaultMessageSelectorKpis, getMetricsKeys, STORE_VISITS } from '@/helpers/reporting.helpers';
import { reportingSetCartographyMapConfig } from '@/store/actions/reporting.actions';
import {
  getMapEvents,
  getMapLoading,
  getMetricsAndKpisByType,
  getReportingType
} from '@/store/selectors/reporting.selectors';
import { VariableSettingsStyled } from './variableSettings.style';

type Props = {
  mapId: MapComponent['id'];
};

export function VariableSettings({ mapId }: Props) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const isDooh = isDOOHCampaign(useSelector(getReportingType));
  const mapEvents = useSelector(getMapEvents);
  const metricsAndKpi = useSelector(getMetricsAndKpisByType);
  // @ts-ignore
  const isLoading = useSelector(store => getMapLoading(store, mapId));
  const metricsAndKpiFiltered = metricsAndKpi.filter(item => !STORE_VISITS.includes(item));
  const { getMap, getMaps, setMapSettings } = useReportingMap();
  const map = getMap({ id: mapId });
  const { settings, type } = map!;
  const shouldExpanded = getMaps().length === 2;
  const eventsByType: string[] = type === 'cartography' || type === 'screens' ? metricsAndKpiFiltered : mapEvents;

  const getMetricOptions = (selectorOptions: string[]) => {
    return selectorOptions.map(option => {
      return {
        id: getMetricsKeys(option),
        label: formatMessage({
          defaultMessage: getDefaultMessageSelectorKpis(option) as string,
          id: `reporting.metrics.${option}`
        })
      };
    });
  };

  const eventOptions = getMetricOptions(eventsByType);
  const selectedEvents = eventOptions.length ? eventOptions.filter(e => settings[type].events.includes(e.id)) : null;

  const handleSelectorChange = (value: Record<string, any> | Record<string, any>[]) => {
    const newValue =
      type === 'single' ? (value as Record<string, any>[]).map(v => v.id) : [(value as Record<string, any>).id];
    setMapSettings({
      id: mapId,
      value: {
        ...settings,
        [type]: {
          ...settings[type],
          events: newValue
        }
      }
    });
    dispatch(
      reportingSetCartographyMapConfig({
        metric: newValue[0]
      })
    );
  };

  const containerClassName = cn('variableSettings__container', {
    'variableSettings__container--expanded': shouldExpanded
  });

  return (
    <VariableSettingsStyled id={`variableSettings_${mapId}`}>
      <div className={containerClassName}>
        <span className="variableSettings__title">
          {formatMessage({
            defaultMessage: 'Metrics & KPIs',
            id: `reporting.map.innerControls.variableSettings.title${isDooh ? 'DOOH' : ''}`
          })}
        </span>
        <Selector
          className="variableSettings__selector"
          defaultValue={selectedEvents as SelectorOptionPropsInterface[]}
          isDisabled={isLoading}
          onChange={handleSelectorChange}
          options={eventOptions}
          type={type === 'single' ? 'multiple' : 'simple'}
          value={selectedEvents as SelectorOptionPropsInterface[]}
        />
      </div>
    </VariableSettingsStyled>
  );
}
